import { REWARD_ACTION_TYPE } from "./reward.action";

export const REWARD_MESSAGE_CONTEXT = {
	error: "[Reward] Error",
	success: "[Reward] Success",
	getReward: REWARD_ACTION_TYPE.get,
	getRewards: REWARD_ACTION_TYPE.getAll,
	claimReward: REWARD_ACTION_TYPE.claim,
	forfeitReward: REWARD_ACTION_TYPE.forfeit,
};

export const REWARD_MESSAGE_CODE = {
	reward: {
		error: "E_REWARDS",
		notFound: "E_REWARDS_REWARDNOTFOUND",
		malformedIdentifier: "E_REWARDS_MALFORMEDIDENTIFIER",
		notAvailableForCustomer: "E_REWARDS_REWARDNOTAVAILABLEFORCUSTOMER",
	},
	claimReward: {
		error: "E_REWARDS_UNABLETOCLAIMREWARD",
		malformedClaim: "E_REWARDS_MALFORMEDCLAIM",
		success: "M_CLAIM_REWARD_SUCCESS",
	},
	forfeitReward: {
		warning: "M_FORFEIT_REWARD_WARNING",
		success: "M_FORFEIT_REWARD_SUCCESS",
	},
};
